import React from 'react';

export default class HistoryHeader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={`calc-header-flex ${this.props.className ?? ''}`}>
                <div className={`header-block-2 ${this.props.active_page === 0 ? 'active' : ''}`}>栄養計算履歴<br/>選択</div>
                <div className={`header-block-2 ${this.props.active_page === 1 ? 'active-end' : ''}`}>計算結果</div>
            </div>
        );
    }
}